import { FC } from 'react';

export type UploadState = {
  /** 0〜100。アップロード開始前(画像の準備中など)は null */
  progress: number | null;
  /** 転送が止まっている可能性がある */
  stalled: boolean;
};

interface Props {
  uploadState: UploadState;
  onCancel?: () => void;
}

export const UploadStatusBar: FC<Props> = ({ uploadState, onCancel }) => {
  const { progress, stalled } = uploadState;

  return (
    <div className="border-t bg-white px-3 py-2 text-sm" role="status" aria-live="polite">
      <div className="flex items-center justify-between gap-3">
        <span>{progress === null ? '画像を準備中…' : `画像を送信中… ${progress}%`}</span>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="shrink-0 rounded border border-gray-300 px-3 py-1 text-xs font-semibold text-gray-600"
          >
            キャンセル
          </button>
        )}
      </div>
      <div className="mt-1 h-1.5 w-full overflow-hidden rounded bg-gray-200">
        <div className="bg-brand h-full transition-all" style={{ width: `${progress ?? 0}%` }} />
      </div>
      {stalled && (
        <p className="mt-1 text-xs text-red-600">
          通信が不安定です。しばらく待つか、キャンセルして再度お試しください
        </p>
      )}
    </div>
  );
};
